import React, { useCallback } from 'react';
import { useModal } from 'components/shared';
import { GlpSignUpTypeformModal } from './GlpSignUpTypeformModal';

export const useGlpSignUp = () => {
  const modal = useModal();

  return useCallback(() => {
    modal.set(React.createElement(GlpSignUpTypeformModal));
    modal.setCloseButtonTheme('light');
    modal.show();
    modal.setPortal(true);
  }, [modal]);
};
